import React from 'react'

import { Layout } from 'antd'
import MenuContent from '../baseLayout/menu'
const { Content, Sider } = Layout

import styles from '../baseLayout/index.less'

export default (props: any) => (
	<Layout className={styles.container}>
		<Sider width={174} className={styles.sider}>
			<MenuContent hasSubMenu={false} />
		</Sider>
		<Layout style={{ padding: 0 }}>
			<Content className={styles.content}>{props.children}</Content>
		</Layout>
	</Layout>
)
